import { render } from "./Volunteering.vue?vue&type=template&id=96a7083a&scoped=true"
import script from "./Volunteering.vue?vue&type=script&lang=js"
export * from "./Volunteering.vue?vue&type=script&lang=js"

import "./Volunteering.vue?vue&type=style&index=0&id=96a7083a&scoped=true&lang=scss"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96a7083a"]])

export default __exports__